import { render, staticRenderFns } from "./blackresultmian.vue?vue&type=template&id=0a6f9394&scoped=true&"
import script from "./blackresultmian.vue?vue&type=script&lang=js&"
export * from "./blackresultmian.vue?vue&type=script&lang=js&"
import style0 from "./blackresultmian.vue?vue&type=style&index=0&id=0a6f9394&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f9394",
  null
  
)

export default component.exports